module.exports = __webpack_public_path__ + "static/media/fisttitle.cbf5ed71.png";